

































































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import CheckInput from '~/components/inputs/CheckInput.vue';
import Dropdown from '~/components/partials/Dropdown.vue';

@Component({
  components: { ChevronRightSolid, CheckInput, Dropdown },
})
export default class CheckBoxesDropdown extends Vue {
  @Prop(Array) elements: [];
  @Prop(Number) selectedLength: 0;
  @Prop(String) label: '';

  filtersArray: {id: string, checked: boolean, name: string}[] = [];

  $refs: {
    dropdown: HTMLButtonElement;
    chevron: Vue,
  };

  /*
    This method will handle user choice when iteracts with dropdown, then emit
    an array of choices to the parent, where the logic will be handled.
    The method will check if chosen element is already in array, if yes it will
    be removed. If not, we push it in array.
  */
  @Emit('emit-list')
  populateFilterArray (element: {id: string, checked: boolean, name: string}) {
    const isDuplicated = !element.checked || this.filtersArray.filter(item => item.id === element.id).length === 1;
    if (!isDuplicated) {
      this.filtersArray.push(element);
    } else {
      /* eslint array-callback-return: 0 */
      this.filtersArray.map((filter, index) => {
        if (filter.id === element.id) {
          this.filtersArray.splice(index, 1);
        }
      });
    }
    return this.filtersArray.slice(0);
  }

  /*
    This watcher will be triggered if this.elements props is defined.
    We populate this.filtersArray so it will contain right datas if user selects
    some in checkboxes.
  */
  @Watch('elements')
  handlePrefilled () {
    const array: {id: string, checked: boolean, name: string}[] = [];
    this.elements?.map((e: {id: string, checked: boolean, name: string}) => {
      if (e.checked) array.push(e);
    });
    this.filtersArray = array;
  }

  mounted () {
    // Force reset the checkboxes selected
    this.$root.$on('reset-checkboxes', () => {
      this.filtersArray = [];
    });

    // We ensure the preselected datas method is well called, as SSR mode will
    // not watch right away if this.elements is defined.
    this.$nextTick(() => {
      this.handlePrefilled();
    });
  }

  /* Utils method to handle dropdown  */
  handleClick (val: boolean) {
    if (!val) this.bluredBtn();
    else this.focusedBtn();
  }

  /* Applies active dropdown styles */
  focusedBtn () {
    this.$refs.dropdown.classList.remove('border-gray-200');
    this.$refs.dropdown.classList.add('border-gray-default');
    this.$refs.chevron.$el.classList.add('-rotate-180', '-rotate-90');
  }

  /* Applies blured dropdown styles */
  bluredBtn () {
    if (this.selectedLength === 0) this.$refs.dropdown.classList.remove('border-gray-default');
    this.$refs.chevron.$el.classList.remove('-rotate-180', '-rotate-90');
  }
}
